import { Medium } from "@bkry/bowline-components/Medium";
import { getUnlockableContentAttributes } from "@bkry/bowline-redux/unlockableContents";
import PropTypes from "prop-types";
import React from "react";
import Avatar from "react-avatar";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody } from "reactstrap";
/**
 * Table container used as app default landing page
 */
const UnlockableContentPreview = ({ unlockableContentId }, context) => {
  const unlockableContent = useSelector((state) =>
    getUnlockableContentAttributes(state, unlockableContentId)
  );
  const locale = useSelector((state) => state?.i18nState?.lang);

  return (
    <Card className="p-0 h-100 rounded-4">
      <div className="position-absolute top-0 bottom-0 start-0 end-0 ratio ratio-1x1 card-img rounded-4 overflow-hidden">
        {unlockableContent && !unlockableContent?.public_medium_thumbnail && (
          <Avatar name={unlockableContent?.title} className="w-100 h-100" />
        )}
        {unlockableContent?.public_medium_thumbnail &&
          unlockableContent?.public_medium_metadata && (
            <Medium
              mediumData={{
                ...unlockableContent?.public_medium_thumbnail,
                ...unlockableContent?.public_medium_metadata,
              }}
              altTitle={unlockableContent?.title}
            />
          )}
      </div>
      <div className="z-1 ratio ratio-1x1">
        <CardBody className="d-flex flex-column align-items-center p-2 p-md-3">
          <p
            className="text-center text-light fw-bold mt-auto"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {unlockableContent.title}
          </p>
          <Link
            to={`/${locale}/community/benefits/extras/${unlockableContentId}`}
            className="btn btn-primary btn-sm px-3 stretched-link rounded-pill"
          >
            {context.t("View")}
          </Link>
        </CardBody>
      </div>
    </Card>
  );
};

/**  define proptype for the 'translation' function  */
UnlockableContentPreview.contextTypes = {
  t: PropTypes.func,
};

UnlockableContentPreview.propTypes = {
  unlockableContentId: PropTypes.string.isRequired,
};

/** export the component as redux connected component */
export default UnlockableContentPreview;
